

























import { getValuesIdxByMetric, getMetricLabel } from "@/utils/chart";
import { PREFIX_HIT_RATE_LABEL } from "@/config/series";
import { PREVIEW_PREFIXES_STATS } from "@/config/preview";
import { Prefix } from "@/types/debug-mode";
import { SeriesPoint } from "@/types/common";
import { TimeRange } from "@/types/time-range";
import GetPrefixStats from "@/mixins/get-prefix-stats";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class PrefixItemStats extends Mixins(GetPrefixStats) {
  created() {
    if (!this.isDisabled) {
      this.getPrefixStats(this.prefix.id, TimeRange.LAST_DAY);
    }
  }

  beforeDestroy() {
    if (!this.isDisabled) {
      this.cleanUpPrefixStats();
    }
  }

  @Getter("debugMode/prefixLastStats") lastStats!: (prefixID: number) => SeriesPoint | null | false;

  @Getter("debugMode/prefixStatsSeriesColumns") columns!: (prefixID: number) => false | string[];

  @Prop({ required: true })
  prefix!: Prefix;

  @Prop({ required: false, default: false })
  isDisabled!: boolean;

  hitRateLabel = PREFIX_HIT_RATE_LABEL;

  getPercentByMetric(metricID: string) {
    // if disabled, show sample preview data
    if (this.isDisabled) {
      return PREVIEW_PREFIXES_STATS[this.prefix.id][metricID];
    }

    const columns = this.columns(this.prefix.id);
    if (!columns) return "-";

    const lastStats = this.lastStats(this.prefix.id);
    if (!lastStats) return "-";

    const i = getValuesIdxByMetric(columns, metricID);
    const val = lastStats[i];
    if ((val === 0 || val) && typeof val === "number") {
      return `${(val * 100).toFixed()}%`;
    }
    // if val is not a number, treat as data unavailable
    return "-";
  }

  metricLabel(metricID: string): string {
    return getMetricLabel(metricID);
  }
}
